import { render, staticRenderFns } from "./ModalAppointmentList.vue?vue&type=template&id=0c225151&scoped=true&"
import script from "./ModalAppointmentList.vue?vue&type=script&lang=js&"
export * from "./ModalAppointmentList.vue?vue&type=script&lang=js&"
import style0 from "./ModalAppointmentList.vue?vue&type=style&index=0&id=0c225151&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c225151",
  null
  
)

export default component.exports